<template>
    <div class="message-notification">
        <div class="message-content" :style="{'width': msgWidth+'px', 'color': msgColor}">
            <transition name="turn">
                <p :key="messageData.id"><i class="fa fa-volume-up" v-show="msgData.length !== 0" aria-hidden="true"></i> {{messageData.val}}</p>
            </transition>
        </div>
    </div>
</template>

<script>
/* eslint-disable */

export default {
    data() {
        return {
            number: 0
        }
    },
    props: {
        msgWidth: Number,
        msgColor: String,
        msgData: Array,
    },
    mounted() {
        this.scrollEvent();
    },
    computed: {
        messageData: function () {
            return {
                val: this.msgData[this.number],
                id: this.number
            }
        }
    },
    methods: {
        // 消息通知滚动事件
        scrollEvent() {
            if (this.msgData) {
                var msgData_len = this.msgData.length;
                if (msgData_len !== 0) {
                    var new_data_len = msgData_len - 1;
                } else {
                    var new_data_len = msgData_len
                }
                const scrollTimer = setTimeout(() => {// 每隔5秒滚动一次
                    if (this.number == new_data_len) {
                        this.number = 0;
                    } else {
                        this.number ++;
                    }
                    this.scrollEvent();
                }, 5000)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .message-notification{
        .message-content{
            width: 300px;
            overflow: hidden;
            height: 20px;
            p{
                height: 20px;
                line-height: 20px;
                text-align: center;
            }
            .turn-enter-active, .turn-leave-active {
                transition: all 0.5s linear;
            }

            .turn-enter {
                transform: translateY(20px) scale(1);
                opacity: 1;
            }

            .turn-leave-to {
                transform: translateY(-20px) scale(0.8);
                opacity: 0;
            }
        }
    }
</style>
